import {iosBridge} from './bridge';

export interface IosDeviceDependencies {
  bridge?: DeviceMessageBridge;
}

export function sendMessage(message: Message, di: IosDeviceDependencies = {}): void {
  const {bridge = iosBridge} = di;
  if (!bridge.sendMessage) return;
  bridge.sendMessage(message);
}
